// Put your application javascript here
function goToLibrary(href) {
  window.location.href = href;
}

function decrementValueOnItem(item, step = 1) {
  if (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) >
    step
  ) {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = (
      parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) -
      step
    ).toString();
  }
}

function incrementValueOnItem(item, step = 1) {
  item.parentNode.querySelectorAll("input[type=text]")[0].value = (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) +
    step
  ).toString();
}

function updateCartCounter(quantity) {
  const cartCounter = document.getElementById("cart-counter");
  if (quantity > 0) {
    cartCounter.classList.remove("hidden");
    cartCounter.classList.add("flex");
  } else {
    cartCounter.classList.add("hidden");
  }
  cartCounter.innerHTML = quantity;
}

function handlebtn(e, button_link) {
  if (e.keyCode == 13) {
    window.location.href = button_link;
  }
}

function setFullImageHeight() {
  var screen_height = window.innerHeight;
  if (
    document.getElementById("shopify-section-navbar") !== undefined &&
    document.getElementById("shopify-section-navbar") !== null
  ) {
    var navbar_height = document.getElementById(
      "shopify-section-navbar"
    ).offsetHeight;
    if (document.getElementById("shopify-section-announcement") != null) {
      var announcement_height = document.getElementById(
        "shopify-section-announcement"
      ).offsetHeight;
      var set_height = screen_height - (announcement_height + navbar_height);
    } else {
      var set_height = screen_height - navbar_height;
    }
    var full_height = set_height + "px";
    var el_list = document.getElementsByClassName("full_img");
    for (var i = 0; i < el_list.length; i++) {
      el_list[i].style.height = full_height;
      el_list[i].style.maxHeight = "fit-content";
    }
  }
}

const crypt = (salt, text) => {
  return CryptoJS.AES.encrypt(text, salt);
};

const decrypt = (salt, text) => {
  return CryptoJS.AES.decrypt(text, salt).toString(CryptoJS.enc.Utf8);
};

function splitLastOccurrence(str, substring) {
  const lastIndex = str.lastIndexOf(substring);
  const before = str.slice(0, lastIndex);
  const after = str.slice(lastIndex + 1);
  return [before, after];
}

window.addEventListener("load", function () {
  if (
    document.getElementById("signup-form") != null &&
    document.getElementById("signup-form") != undefined
  ) {
    var dataattributes = JSON.parse(
      document.getElementById("signup-form").getAttribute("data-params")
    );
    console.log(dataattributes);
    if (
      getCookie("direct-sale-manager") &&
      getCookie("direct-sale-manager-utm")
    ) {
      dataattributes.welcomePagePath =
        dataattributes.welcomePagePath +
        "?" +
        getCookie("direct-sale-manager-utm");
      document
        .getElementById("signup-form")
        .setAttribute(
          "data-params",
          JSON.stringify(dataattributes, null, "\t")
        );
    }
  }

  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((data) => updateCartCounter(data.item_count));

  setFullImageHeight();

  setTimeout(function () {
    const headerLoader = document.querySelectorAll(".hear-loader");
    if (headerLoader.length > 0) {
      headerLoader.forEach((el) => {
        el.style.display = "none";
      });
    }
  }, 2000);
});

window.addEventListener(
  "resize",
  function (_event) {
    setFullImageHeight();
  },
  true
);

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

// Function to handle cart hash detection and opening
function handleCartHash() {
  if (window.location.hash === "#cart") {
    // Check if CBI cart is enabled, otherwise use Bloom
    if (window.CBI_CART_PANEL_ENABLED !== false) {
      // Use the existing showCBICart function from cbi_cart.js
      if (typeof showCBICart === "function") {
        showCBICart();
      }
    } else {
      // Fall back to Bloom cart if CBI cart is disabled
      if (window.bloom && typeof bloom.showCart === "function") {
        bloom.showCart();
      }
    }
  }
}

// Check for cart hash on page load
document.addEventListener("DOMContentLoaded", function () {
  handleCartHash();
});

// Listen for hash changes (when user navigates to /#cart)
window.addEventListener("hashchange", function () {
  handleCartHash();
});

/*  
    Adds an empty "alt" attribute to 1x1 tracking pixel images dynamically
    appended to the DOM that violates WCAG 1.1.1 Non-text Content (Level A)
    This implementation observes only to direct descendants of body tag.
*/
(function() {
  'use strict';
  
  // Private function to add missing alt tags to 1x1 tracking pixel images
  function addMissingAltTags() {
    // Check if MutationObserver is supported (IE11+)
    if (!window.MutationObserver) return;
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(mutation => {
        Array.from(mutation.addedNodes)
          .filter(node => node.nodeType === 1 && node.tagName === 'IMG')
          .forEach(imgNode => {
            const width = imgNode.getAttribute('width');
            const height = imgNode.getAttribute('height');

            // Ensure this is actually a 1x1 tracking pixel, not a content image
            if (width === '1' && height === '1' && !imgNode.hasAttribute('alt')) {
              imgNode.setAttribute('alt', '');
            }
          });
      });
    });
    
    // Only observe direct children of body
    observer.observe(document.body, {
      childList: true,
      subtree: false  // Key optimization: watch only direct body children
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addMissingAltTags);
  } else {
    addMissingAltTags();
  }
})();
